// Sichtbare Texte des Charts. Bewusst hier und nicht in den App-Translations:
// die Komponente soll sich mit einer Prop einbauen lassen, ohne dass der
// Aufrufer ein Textpaket mitliefern muss.

export const STRINGS = {
    de: {
        heading: "Prediction-Market implizierter Leitzins",
        impliedFor: "impliziert für",
        anchorToday: "Anchor heute",
        pricedIn: "Eingepreist",
        nextMeeting: "Nächstes Meeting",
        distribution: "Verteilung",
        anchorPlain: "Anchor",
        basisBefore: "Basis vor dem Meeting",
        pricedMeeting: "Bepreistes Meeting",
        live: "aktuell",
        dayToday: "heute",
        dayTomorrow: "morgen",
        inDays: "in {n} Tagen",

        b_fed: "USD",
        b_fed_sym: "$",
        b_ecb: "EUR",
        b_ecb_sym: "€",
        bankFed: "Fed · Federal Funds",
        bankEcb: "EZB · Einlagesatz",
        bankAria: "Währungsraum wählen",

        // Beschlossen, aber noch nicht wirksam: die EZB kündigt am Donnerstag
        // an, der Satz gilt ab dem folgenden Mittwoch. Der Wirksamkeitstag ist
        // Mitternacht UTC und wird nur als Datum gezeigt.
        decided: "Beschlossen",
        effectiveFrom: "wirksam ab {d}",
        announcedOn: "beschlossen am {d}",
        notYetEffective: "noch nicht wirksam",
        inForce: "In Kraft",

        // Entscheidung im Kopf: Richtung in Worten, damit niemand das Vorzeichen
        // eines Basispunktwerts deuten muss.
        hike: "Anhebung",
        cut: "Senkung",
        hold: "Keine Änderung",
        decisionLikely: "Erwartete Entscheidung",
        decisionMade: "Beschluss",
        probability: "Wahrscheinlichkeit",
        pricedThen: "damals eingepreist",
        modal: "Wahrscheinlichster Ausgang",
        meetingOn: "Meeting am",

        r_m1: "Letztes Meeting",
        r_m3: "3 Meetings",
        r_y1: "1 Jahr",
        r_all: "Alles",
        m_rate: "Rate",
        m_delta: "Änderung",
        history: "Historie · täglich",
        today: "heute",
        forward: "erwartet",
        anchor: "Anchor",
        expectedUntil: "erwartet bis",
        over: "über",
        meetingsWord: "Meetings",
        close: "Schluss",
        decision: "Entscheidung",
        expectedChange: "erwartete Änderung",
        asOf: "Stand",
        method: "Methodik",
        source: "Quelle Polymarket",
        times: "Zeiten in",
        errNetwork: "Die Daten konnten nicht geladen werden. Bitte später erneut versuchen.",
        errSchema: "Das Datenformat hat sich geändert. Bitte die Seite neu laden.",
        aria: "Prediction-Market implizierter Leitzins: Historie und erwarteter Pfad",
    },
    en: {
        heading: "Prediction-Market implied policy rate",
        impliedFor: "implied for",
        anchorToday: "Anchor today",
        pricedIn: "Priced in",
        nextMeeting: "Next meeting",
        distribution: "Distribution",
        anchorPlain: "Anchor",
        basisBefore: "Basis before the meeting",
        pricedMeeting: "Meeting priced",
        live: "current",
        dayToday: "today",
        dayTomorrow: "tomorrow",
        inDays: "in {n} days",

        b_fed: "USD",
        b_fed_sym: "$",
        b_ecb: "EUR",
        b_ecb_sym: "€",
        bankFed: "Fed · Federal Funds",
        bankEcb: "ECB · Deposit facility",
        bankAria: "Select currency area",

        decided: "Decided",
        effectiveFrom: "effective {d}",
        announcedOn: "decided on {d}",
        notYetEffective: "not yet effective",
        inForce: "In force",

        hike: "Hike",
        cut: "Cut",
        hold: "No change",
        decisionLikely: "Expected decision",
        decisionMade: "Decided",
        probability: "probability",
        pricedThen: "priced in at the time",
        modal: "Most likely outcome",
        meetingOn: "Meeting on",

        r_m1: "Last meeting",
        r_m3: "3 meetings",
        r_y1: "1 year",
        r_all: "All",
        m_rate: "Rate",
        m_delta: "Change",
        history: "History · daily",
        today: "today",
        forward: "expected",
        anchor: "Anchor",
        expectedUntil: "expected by",
        over: "across",
        meetingsWord: "meetings",
        close: "Close",
        decision: "Decision",
        expectedChange: "expected change",
        asOf: "As of",
        method: "Methodology",
        source: "Source Prediction-Market",
        times: "Times in",
        errNetwork: "The data could not be loaded. Please try again later.",
        errSchema: "The data format has changed. Please reload the page.",
        aria: "Prediction-Market implied policy rate: history and expected path",
    },
};

export type Strings = typeof STRINGS.de;

export function stringsFor(language: string): Strings {
    return language === "en" ? STRINGS.en : STRINGS.de;
}